import debounce from 'lodash/debounce';

const getCbDebouncer = () => {
    return debounce(callback => callback(), 300, {leading: false, trailing: true});
};

export default getCbDebouncer;